import { useAvailabilityColumnStore } from '@/stores';
import { useAvailabilityCrossDnd, addSidebarPrefix } from './AvailabilityCrossDndContext';
import { createColumnManagerPanel } from '@/components/shared/createColumnManagerPanel';
import type { CreateColumnManagerPanelConfig } from '@/components/shared/createColumnManagerPanel';

export const AvailabilityColumnManagerPanel = createColumnManagerPanel({
  useColumnStore: useAvailabilityColumnStore as CreateColumnManagerPanelConfig['useColumnStore'],
  useCrossDnd: useAvailabilityCrossDnd,
  addSidebarPrefix,
});
